import { Helmet } from "react-helmet-async";

const SITE = "Get Skilled in Days Not Years";
const origin = typeof window !== "undefined" ? window.location.origin : "https://www.virtualspeedyservices.uk";

export function Seo({ title, description, path = "", image, jsonLd, noindex = false }) {
  const fullTitle = title ? `${title} — ${SITE}` : SITE;
  const url = `${origin}${path}`;
  const img = image || `${origin}/logo.png`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
